import { FC } from "react";
import { CASE_TIMELINE_ITEM } from "./CaseSummary";
import { CASE_TIMELINE_TYPE, MILESTONE_TIMELINE } from "../types/CommonTypes";
import MilestoneTimeline from "./MilestoneTimeline";
import VoiceNoteTimeline from "./VoiceNoteTimeline";
import TimerNoteTimeline from "./TimerNoteTimeline";
import NotificationNoteTimeline from "./NotificationNoteTimeline";
import ConflictAlertTimeline from "./ConflictAlertTimeline";

interface CaseTimelineProps {
  data?: Array<CASE_TIMELINE_ITEM>;
  hideLine?: boolean;
  isEditMode?: boolean;
  onRevisionPress?: (item: CASE_TIMELINE_ITEM) => void;
}

const CaseTimeline: FC<CaseTimelineProps> = ({
  data = [],
  hideLine = false,
  isEditMode = false,
  onRevisionPress,
}) => {
  return (
    <>
      {data.map((item, index) => {
        const prevItem = index > 0 ? data[index - 1] : undefined;
        const priorMilestone =
          prevItem && prevItem.type === CASE_TIMELINE_TYPE.MILESTONE
            ? (prevItem as MILESTONE_TIMELINE)
            : undefined;

        switch (item.type) {
          case CASE_TIMELINE_TYPE.MILESTONE: {
            return (
              <MilestoneTimeline
                key={item.milestoneId + index}
                item={item}
                hideLine={hideLine}
                isNotLast={index !== data.length - 1}
                isEditMode={isEditMode}
                timelineItemIndex={index}
                onRevisionPress={onRevisionPress}
                priorMilestone={priorMilestone}
              />
            );
          }

          case CASE_TIMELINE_TYPE.VOICE_NOTE: {
            return (
              <VoiceNoteTimeline
                key={item.id}
                item={item}
                hideLine={hideLine}
                isNotLast={index !== data.length - 1}
                isEditMode={isEditMode}
                timelineItemIndex={index}
              />
            );
          }

          case CASE_TIMELINE_TYPE.TIMER: {
            return (
              <TimerNoteTimeline
                key={item.id}
                item={item}
                hideLine={hideLine}
                isNotLast={index !== data.length - 1}
                isEditMode={isEditMode}
                timelineItemIndex={index}
              />
            );
          }

          case CASE_TIMELINE_TYPE.NOTIFICATION: {
            return (
              <NotificationNoteTimeline
                key={item.id}
                item={item}
                hideLine={hideLine}
                isNotLast={index !== data.length - 1}
              />
            );
          }

          case CASE_TIMELINE_TYPE.CONFLICT_ALERT: {
            return (
              <ConflictAlertTimeline
                key={item.id}
                hideLine={hideLine}
                isNotLast={index !== data.length - 1}
                item={item}
              />
            );
          }

          default: {
            return null;
          }
        }
      })}
    </>
  );
};

export default CaseTimeline;
